import LuckyDeeplink from '../constants/lucky.deeplink';
import uuid from '../utils/uuid.utils';
import DeviceUtils from '../utils/device.utils';

export class DeeplinkEvent {
  static open(deeplink, extraData = {}) {
    window.__CAAS__.triggerNative(window.__CAAS__.events.openDeeplink, uuid(), {
      ...extraData,
      deeplink,
    });
  }

  static openWebview(path = '', extraData = {}) {
    const webviewUrl = DeeplinkEvent.getFullURL(path);

    const url = `${LuckyDeeplink.OPEN_WEBVIEW}?url=${btoa(webviewUrl)}`;

    window.__CAAS__.triggerNative(window.__CAAS__.events.openDeeplink, uuid(), {
      ...extraData,
      deeplink: url,
    });
  }

  static loginAndRedirect(path = '', extraData = {}) {
    const url = `${LuckyDeeplink.LOGIN}?loginPath=connect&url=${btoa(
      DeeplinkEvent.getFullURL(path),
    )}`;
    window.__CAAS__.triggerNative(window.__CAAS__.events.openDeeplink, uuid(), {
      ...extraData,
      deeplink: url,
    });
  }

  static getFullURL(path) {
    if (process.env.PREACT_APP_IS_LOCAL === 'true') {
      return `${window.location.protocol}//${window.location.hostname}:8080${path}`;
    }

    return `${window.location.protocol}//${window.location.hostname}${path}`;
  }
}
